var _defs, _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNobinaPaymentCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6_copy",
    "data-name": "Layer 6 copy",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d1d1b;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3,
    y: 3,
    width: 94,
    height: 58
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,4.73v54.55c0,2.5,2.05,4.55,4.55,4.55h90.91c2.5,0,4.55-2.05,4.55-4.55V4.73c0-2.5-2.05-4.55-4.55-4.55H4.55C2.05.18,0,2.23,0,4.73ZM95.45,4.73v54.55H4.55V4.73h90.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.55,50.18h-13.64c-1.25,0-2.27,1.02-2.27,2.27s1.02,2.27,2.27,2.27h13.64c1.25,0,2.27-1.02,2.27-2.27s-1.02-2.27-2.27-2.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.27,50.18h-13.64c-1.25,0-2.27,1.02-2.27,2.27s1.02,2.27,2.27,2.27h13.64c1.25,0,2.27-1.02,2.27-2.27s-1.02-2.27-2.27-2.27Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 13.82,
    width: 100,
    height: 13.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNobinaPaymentCard1);
export default __webpack_public_path__ + "static/media/Nobina_payment_card 1.94e20bb0b2a8e2bed5fa065124885292.svg";
export { ForwardRef as ReactComponent };